import { changeSalesPriceBasis } from "utils/sales_price_basis"
import { preventImplicitSubmit } from "../../../../../app/javascript/keyboard/form_keys"
import { fetchVariantDetails } from "utils/variant_details"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form", "itemTemplate", "itemsContainer", "itemsPanel", "subtotal", "deliveryMethod", "deliveryFee", "tax", "total"]
    static values = { itemVariantsUrl: String }

    changePriceBasis(event) {
        const row = event.target.closest(".item-container")
        changeSalesPriceBasis(row, event.target, "input[name$='[estimated_weight]']")
        this.calculateQuote()
    }

    connect() {
        this.itemVariants = []
        this.variantOptionContent = null
        this.itemContent = this.itemTemplateTarget.innerHTML

        this.formTarget.addEventListener("keydown", preventImplicitSubmit)


        setTimeout(() => {
            this.clientInput = this.formTarget.querySelector("input[name='quote[client_id]']")
            this.selectedClientId = this.clientInput?.value || ""
            this.clientSelectInput = this.formTarget.querySelector("input[id='quote_client_id_hw_combobox']")
            this.itemsContainerTarget.querySelectorAll("li.item-container").forEach(item => this.configureVariantPicker(item))
            this.clientSelectInput?.focus()
        }, 10)
    }

    addItem(event) {
        if (event) event.preventDefault()
        const content = this.itemContent.replace(/NEW_RECORD/g, new Date().getTime())
        this.itemsContainerTarget.insertAdjacentHTML("beforeend", content)
        const lastItem = this.itemsContainerTarget.querySelector("li.item-container:last-child")
        this.configureVariantPicker(lastItem)
        const firstInput = lastItem.querySelector("input")
        firstInput.focus()
    }

    removeItem(event) {
        event.preventDefault()
        const wrapper = event.target.closest(".item-container")
        wrapper.remove()
    }

    clearItems() {
        this.itemsContainerTarget.innerHTML = ""
    }

    configureVariantPicker(item) {
        const fieldset = item.querySelector("[data-hw-combobox-async-src-value]")
        if (fieldset) fieldset.dataset.hwComboboxAsyncSrcValue = `${this.itemVariantsUrlValue}?client_id=${encodeURIComponent(this.clientInput?.value || "CLIENT_ID")}`
    }

    changeClient(event) {
        if (event) event.preventDefault()

        const clientId = this.clientInput?.value || ""
        if (clientId === this.selectedClientId) return
        this.selectedClientId = clientId
        this.clearItems()
        this.itemsPanelTarget.classList.toggle("d-none", !this.clientIdPresent())
        if (this.clientIdPresent()) this.addItem()
    }

    clientIdPresent() {
        return Boolean(this.clientInput?.value)
    }

    selectVariant(event) {
        if (event) event.preventDefault()
        setTimeout(async () => {
            const item = event.target.closest("li.item-container")
            const input = item.querySelector("input[name$='[item_variant_id]']")
            const id = input.value
            if (!id || !this.clientIdPresent()) return
            const clientId = this.clientInput.value
            const currency = this.element.querySelector('[name="quote[currency]"]')?.value || ""
            try {
                const variant = await fetchVariantDetails(`${this.itemVariantsUrlValue}?client_id=${encodeURIComponent(clientId)}&currency=${encodeURIComponent(currency)}`, id)
                if (!item.isConnected || input.value !== id || this.clientInput.value !== clientId) return
                item.querySelector("input[name$='[unit_price]']").value = variant.price
                const flag = item.querySelector("[data-quote-weight-flag]")
                flag.value = variant.catch_weight ? "true" : "false"
                const basis = item.querySelector("[data-sales-price-basis]")
                basis.value = variant.sales_price_basis || (variant.catch_weight ? "weight" : "unit")
                basis.dataset.previousBasis = basis.value
                flag.dataset.kgPerUnit = variant.estimated_weight_per_unit || "0"
                item.dataset.estimatedKgPerUnit = variant.estimated_weight_per_unit || "0"
                item.querySelector("[data-quote-weight-fields]").classList.toggle("d-none", !variant.catch_weight)
                const qty = Number(item.querySelector("input[name$='[quantity]']").value)
                item.querySelector("input[name$='[estimated_weight]']").value = variant.catch_weight ? (qty * Number(variant.estimated_weight_per_unit)).toFixed(4) : ""
                this.calculateQuote()
                if (item.parentElement.lastElementChild === item) this.addItem()
            } catch (error) { console.error(error) }
        }, 10)
    }

    calculateQuote(event) {
        console.log("calculateQuote")
        if (event) event.preventDefault()
        const items = this.itemsContainerTarget.querySelectorAll("li.item-container")
        console.log(items)
        const subtotal = [...items].reduce((total, item) => {
            const unitPriceInput = item.querySelector("input[name$='[unit_price]']")
            const quantityInput = item.querySelector("input[name$='[quantity]']")
            const unitPrice = Number(unitPriceInput.value)
            const quantity = Number(quantityInput.value)
            const weightFlag = item.querySelector("[data-quote-weight-flag]")?.value
            const tracked = weightFlag === "true" || weightFlag === "1"
            const byWeight = item.querySelector("[data-sales-price-basis]")?.value === "weight"
            const kgInput = item.querySelector("input[name$='[estimated_weight]']")
            if (tracked && event?.target === quantityInput) {
                const perUnit = Number(item.querySelector("[data-quote-weight-flag]").dataset.kgPerUnit || 0)
                kgInput.value = (quantity * perUnit).toFixed(4)
            }
            if (tracked && quantity > 0) item.querySelector("[data-quote-weight-flag]").dataset.kgPerUnit = Number(kgInput.value) / quantity
            item.dataset.lastQuantity = quantity
            return total + unitPrice * (byWeight ? Number(kgInput.value) : quantity)
        }, 0)
        const deliveryFee = 0
        const tax = 0
        const total = subtotal + deliveryFee + tax
        this.subtotalTarget.innerText = Intl.NumberFormat('en-AU', { style: 'currency', currency: this.element.querySelector('select[name$="[currency]"]')?.value || 'AUD', currencyDisplay: 'code' }).format(subtotal)
        this.deliveryFeeTarget.innerText = Intl.NumberFormat('en-AU', { style: 'currency', currency: this.element.querySelector('select[name$="[currency]"]')?.value || 'AUD', currencyDisplay: 'code' }).format(deliveryFee)
        this.taxTarget.innerText = Intl.NumberFormat('en-AU', { style: 'currency', currency: this.element.querySelector('select[name$="[currency]"]')?.value || 'AUD', currencyDisplay: 'code' }).format(tax)
        this.totalTarget.innerText = Intl.NumberFormat('en-AU', { style: 'currency', currency: this.element.querySelector('select[name$="[currency]"]')?.value || 'AUD', currencyDisplay: 'code' }).format(total)
    }
}
